import React from 'react';
import { formatFirebaseTimestamp } from '../../utils/datetime';

export default function Reports({ reports }) {
    return (
        <div style={{ flex: 1 }}>
            <table className="request-table">
                <thead>
                    <tr className="request-row">
                        <th>ID</th>
                        <th>Type</th>
                        <th>Reported By</th>
                        <th>Content</th>
                        <th>Status</th>
                        <th>Created At</th>
                    </tr>
                </thead>
                <tbody>
                    {reports.length === 0 ? (
                        <tr>
                            <td colSpan={6} className="empty-state">No reports found</td>
                        </tr>
                    ) : reports.map((report, index) => (
                        <tr key={index} className="request-row">
                            <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{report?.id}</td>
                            <td>{report?.type ?? '—'}</td>
                            <td>{report?.reportedBy ?? report?.userId ?? '—'}</td>
                            <td style={{ maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {report?.content ?? report?.description ?? report?.reason ?? '—'}
                            </td>
                            <td>{report?.status ?? '—'}</td>
                            <td>{formatFirebaseTimestamp(report?.createdAt)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
